import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaTachometerAlt, FaStore, FaUsers, FaExclamationTriangle,
  FaMoneyBillWave, FaCog, FaClipboardList, FaTrophy,
  FaFileAlt, FaBars, FaTimes, FaDesktop, FaTools, FaGlobe, FaBuilding,
  FaBell, FaTicketAlt, FaChartBar, FaCommentAlt, FaTruck, FaCalculator,
} from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

// Mühasib rolu yalnız bunu görür
const ACCOUNTANT_MENU = [
  { path: '/accounting', icon: FaCalculator, label: 'Mühasibatlıq 📊' },
];

const MENU = [
  { path: '/dashboard',     icon: FaTachometerAlt,      label: 'Dashboard' },
  { path: '/analytics',     icon: FaChartBar,            label: 'Analitika 📊' },
  { path: '/monitoring',    icon: FaDesktop,             label: 'Monitorinq', badge: '🔴' },
  { path: '/interventions', icon: FaTools,               label: 'Müdaxilələr' },
  { path: '/applications',  icon: FaFileAlt,             label: 'Müraciətlər' },
  { path: '/businesses',    icon: FaStore,               label: 'Businesses' },
  { path: '/users',         icon: FaUsers,               label: 'İstifadəçilər' },
  { path: '/leaderboards',  icon: FaTrophy,              label: 'TOP 5 🏆' },
  { path: '/fraud',         icon: FaExclamationTriangle, label: 'Fraud Alerts' },
  { path: '/finance',       icon: FaMoneyBillWave,       label: 'Maliyyə' },
  { path: '/logs',          icon: FaClipboardList,       label: 'Sistem Loqları' },
  { path: '/corporate',     icon: FaBuilding,            label: 'Korporativ 🏢' },
  { path: '/delivery',      icon: FaTruck,               label: 'Çatdırılma 🚴' },
  { path: '/notifications', icon: FaBell,                label: 'Push Bildirişlər' },
  { path: '/feedback',      icon: FaCommentAlt,          label: 'Təklif & Şikayət 💬' },
  { path: '/coupons',       icon: FaTicketAlt,           label: 'Kuponlar 🎟️' },
  { path: '/promo',         icon: FaTicketAlt,           label: 'Promo Kodlar' },
  { path: '/website',       icon: FaGlobe,               label: 'Vebsayt' },
  { path: '/accounting',    icon: FaCalculator,          label: 'Mühasibatlıq 📊' },
  { path: '/settings',      icon: FaCog,                 label: 'Parametrlər' },
];

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const { admin } = useAuth();
  const menuItems = admin?.role === 'accountant' ? ACCOUNTANT_MENU : MENU;

  const close = () => setOpen(false);

  return (
    <>
      {/* Hamburger */}
      <button className="sa-hamburger" onClick={() => setOpen(o => !o)} aria-label="Menyu">
        {open ? <FaTimes size={20} /> : <FaBars size={20} />}
      </button>

      {/* Overlay */}
      <div className={`sa-sidebar-overlay${open ? ' open' : ''}`} onClick={close} />

      {/* Sidebar */}
      <aside className={`sa-sidebar${open ? ' open' : ''}`}>
        <div style={{ padding: '28px 20px 20px', borderBottom: '1px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
          <h2 style={{ fontSize: 22, fontWeight: 'bold', color: '#FF6B35', margin: 0 }}>GastroQuest</h2>
          <p style={{ fontSize: 12, color: '#999', marginTop: 4 }}>Admin Center</p>
        </div>

        <nav style={{ flex: 1, padding: '16px 0', display: 'flex', flexDirection: 'column', gap: 4, overflowY: 'auto' }}>
          {menuItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={close}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 14,
                padding: '13px 22px', color: isActive ? '#FF6B35' : '#B0B0B0',
                textDecoration: 'none', fontSize: 14, fontWeight: 500,
                borderLeft: `4px solid ${isActive ? '#FF6B35' : 'transparent'}`,
                background: isActive ? 'rgba(255,107,53,0.1)' : 'transparent',
                transition: 'all 0.2s',
              })}
            >
              <item.icon size={18} />
              <span>{item.label}</span>
              {item.badge && (
                <span style={{ marginLeft: 'auto', fontSize: 10 }}>{item.badge}</span>
              )}
            </NavLink>
          ))}
        </nav>

        <div style={{ padding: '16px', borderTop: '1px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
          <p style={{ fontSize: 11, color: '#666', margin: 0 }}>v1.0.0 © 2024 GastroQuest</p>
        </div>
      </aside>
    </>
  );
}
